import { useEffect, useState } from "react";
import firebase from "firebase/app";
import "firebase/auth";
import { IUser } from "@evennt-tech/api-v2-core";
import { apiV2 } from "api/firebase";

interface UserData {
  user: IUser | null;
  loading: boolean;
}

export function useUserWithClaims(): UserData {
  const [userData, setUserData] = useState<UserData>({
    user: null,
    loading: true,
  });

  useEffect(() => {
    let isMounted = true;

    const unsubscribe = firebase.auth().onAuthStateChanged(async (user) => {
      if (!isMounted) return;

      const me = await apiV2.user.getMe();

      if (!me) {
        setUserData({ user: null, loading: false });
        return;
      }

      try {
        setUserData({ user: me, loading: false });
      } catch (error) {
        console.error("Error fetching claims:", error);
        setUserData({ user: null, loading: false });
      }
    });

    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, []);

  return userData;
}
